export default "__VITE_ASSET__BCLxaZb5__"